import { gql, useMutation } from '@apollo/client'
import { path } from 'ramda'
import { useNotification } from '@btime/react-messager'
import React from 'react'

import { compliancesClient, serviceOrdersClient } from '../../utils/apollo/api'
import DynamicInput from '../../components/form/DynamicInput'
import Editable from '../../packages/kiti/components/form/Editable'
import Input from '../../packages/kiti/components/form/Input'

const MUTATION = gql`
  mutation UpsertReply($input: ReplyInput) {
    upsertReply(input: $input) {
      id
    }
  }
`

const ALLOWED_TYPES = ['text', 'numeric', 'integer', 'float', 'number', 'checkbox']
const TEXT_TYPE_INPUTS = ['text', 'numeric', 'integer', 'float', 'number']

const EditableReply = ({ record, children, ...props }) => {
  const notify = useNotification()
  const [request, { loading }] = useMutation(MUTATION, {
    refetchQueries: ['Reply', 'Replies'],
    client: serviceOrdersClient
  })

  const questionType = record.question?.typeName
  if (!record.serviceOrderId || !ALLOWED_TYPES.includes(questionType)) return children

  const handleRequest = value => {
    const params = {
      variables: {
        input: { serviceOrderId: record.serviceOrderId, questionId: record.questionId, value }
      }
    }
    return request(params).then(resp => {
      if (!!resp.errors) {
        notify.error({ title: 'Ocorreu um erro ao salvar!', message: path(['errors', 0, 'message'], resp) })
      } else {
        compliancesClient.cache.reset()
      }
    })
  }

  return (
    <Editable
      value={record.value}
      onSubmit={handleRequest}
      loading={loading}
      Input={DynamicInput}
      valueType={questionType}
      submitOnChange={!TEXT_TYPE_INPUTS.includes(questionType)}
      {...props}
    >
      {children}
    </Editable>
  )
}

export default EditableReply
